export const VERSION = '3.7.23.104';
export const API_VERSION = '1.1.23.104';
export const COPYRIGHT = '2023 © Wireless Business Consultants';
export const ENDPOINTS = {
	// local dev
	//API: 'http://localhost:5008/api',
	//CALL_BACK_URL: 'http://localhost:3000/reset-password'

	// dev
	API: 'https://wbc-admin-api.azurewebsites.net/api',
	//CALL_BACK_URL: 'https://devapi.caa-apps.com/reset-password'


	// prod
	//API: 'https://api.dsp-wireless.com/api',
	//CALL_BACK_URL: 'https://prodapi.caa-apps.com/reset-password'
};


// device, accessories, mobile broadbad & routers, tablets

export const RECAPTCHA = '6LeYoLYUAAAAAGJxTOuLd5UKJJ8jHLrofvBXdEpW';


export const SITE = 'dsp-wireless.com';

export const API_METHOD = {
	POST: 'POST',
	GET: 'GET',
	DELETE: 'DELETE'
};
export const LOCAL_STORAGE = {
	PROFILE: 'wbc-profile',
	TOKEN: 'wbc-token',
	CART: 'wbc-cart',
};
export const SESSION_STORAGE = {
	CUSTOMER_ID: 'customer-id',
	AGENT_ID: 'agent-id',
	TOKEN: 'live-token'
};
export const STATUS = {
	ACTIVE: { ID: 1, VALUE: 'Active' },
	INACTIVE: { ID: 0, VALUE: 'Inactive' },
};

// purchase type
export const PURCHASE_TYPES = [
	//{ value: "BYOD", label: 'BYOD' },
	{ value: "EPP Financing", label: 'EPP Financing' },
	{ value: "Full Price", label: 'Full Price' }
];

// installed app options
export const INSTALLED_APPS = ["Ementor", "Google Maps", "Paycom", "Waze", "Flex", "Chime", "ADP", "Amazon A to Z"];